import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { ReglasComercialesComponent } from './reglas-comerciales/reglas-comerciales.component';

import { DescuentosEspecialesComponent } from './reglas-comerciales/descuentos-especiales/descuentos-especiales.component';
import { PromocionesComponent } from './reglas-comerciales/promociones/promociones.component';
import { CombosComponent } from './reglas-comerciales/combos/combos.component';
import { ModalAddeditDescuentosComponent } from './reglas-comerciales/descuentos-especiales/modal-addedit-descuentos.component';
import { ModalAddeditComboComponent } from './reglas-comerciales/combos/modal-addedit-combo.component';
import { ModalAddeditPromocionComponent } from './reglas-comerciales/promociones/modal-addedit-promocion.component';
import { ModalShowClientesComponent } from './reglas-comerciales/modal-show-clientes/modal-show-clientes.component';
import { ModalReservaComboComponent } from './reglas-comerciales/combos/modal-reserva-combo.component';
import { DescuentosTopesComponent } from './reglas-comerciales/descuentos-topes/descuentos-topes.component';
import { ModalAddeditDescuentosTopesComponent } from './reglas-comerciales/descuentos-topes/modal-addedit-descuentos-topes.component';
import { ConfiguracionSistemaModule } from '../configuracion-sistema/configuracion-sistema.module';

@NgModule({
  declarations: [
    DescuentosEspecialesComponent,
    PromocionesComponent,
    CombosComponent,
    ModalAddeditDescuentosComponent,
    ModalAddeditComboComponent,
    ModalAddeditPromocionComponent,
    ReglasComercialesComponent,
    ModalShowClientesComponent,
    ModalReservaComboComponent,
    DescuentosTopesComponent,
    ModalAddeditDescuentosTopesComponent,
  ],
  imports: [CommonModule, ToastModule.forRoot(), MDBBootstrapModulesPro.forRoot(), Ng9RutModule, FormsModule, ReactiveFormsModule, SharedViewsModule, SharedModule, ConfiguracionSistemaModule],
  exports: [ReglasComercialesComponent],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class AccionesComercialesModule {}
